import { render, staticRenderFns } from "./createActivity.vue?vue&type=template&id=0cad6088&scoped=true"
import script from "./createActivity.vue?vue&type=script&lang=js"
export * from "./createActivity.vue?vue&type=script&lang=js"
import style0 from "./createActivity.vue?vue&type=style&index=0&id=0cad6088&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cad6088",
  null
  
)

export default component.exports